// extracted by mini-css-extract-plugin
module.exports = {"wrap":"substitution-form_wrap__prqiT","rowField":"substitution-form_rowField__qDGAF"};